import React, { Component } from 'react';
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import Divider from 'components/Divider';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { getItem } from 'utils/localStorage';
import { AdminBase } from 'routes/routeNames';
import ToolTip from 'react-portal-tooltip';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component

import styles from './AccountDropdown.scss';// to import local scss fle

class AccountDropdown extends Component {
  static propTypes = {
    logoutUser: PropTypes.func,
    attributes: PropTypes.shape().isRequired,
    logoutCurrentUserForAdmin: PropTypes.bool.isRequired,
    history: PropTypes.shape(),
    userLoggedOut: PropTypes.bool.isRequired,
    match: PropTypes.shape.isRequired,
  };
  static defaultProps = {
    logoutUser: () => {},
    dropDownWithUser: false,
    history: {
      push: () => {},
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      isTooltipActive: false,
      profileIcon: '',
      renderLogOutCurrentUSer: '',
    };
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.logoutCurrentUser = this.logoutCurrentUser.bind(this);
  }

  componentWillMount() {
    const profileImage = getItem('profile_image');
    this.setState({ profileIcon: profileImage });
    const currentUser = getItem('user_cred');
    const currentLocalZone = getItem('localZone');
    if (currentUser) {
      this.setState({ renderLogOutCurrentUSer: true });
    }
    if (currentLocalZone === 'STUDENT') {
      this.setState({ localZone: currentLocalZone });
    } else {
      this.setState({ localZone: currentLocalZone });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.userLoggedOut !== nextProps.userLoggedOut) {
      this.props.history.push('/');
    }
  }

  showTooltip() {
    this.setState({ isTooltipActive: true });
  }
  hideTooltip() {
    this.setState({ isTooltipActive: false });
  }
  logoutCurrentUser() {
    this.props.logoutCurrentUserForAdmin();
    this.props.history.push(AdminBase);
  }
  render() {
    const { match } = this.props;
    const renderCocahLinks = renderIf(this.props.attributes.get('zoneinfo') === 'COACH');
    const renderStudentLinks = renderIf(this.props.attributes.get('zoneinfo') === 'STUDENT');
    const renderAdminLinks = renderIf(this.props.attributes.get('zoneinfo') === 'ADMIN');
    const renderAdminStudentLinks = renderIf(this.state.localZone === 'STUDENT' && match.url !== '/admin/admin_portal');
    const renderAdminCoachLinks = renderIf(this.state.localZone === 'COACH' && match.url !== '/admin/admin_portal');
    const renderLogoutLink = renderIf(this.state.renderLogOutCurrentUSer && match.url !== '/admin/admin_portal' &&
        (this.state.localZone === 'COACH' || this.state.localZone === 'STUDENT') && match.params.id === undefined);
    return (
      <div className={styles.container}>
        {/* eslint-disable*/}
          {renderCocahLinks(
              <img
                  id="text"
                  onMouseEnter={this.showTooltip}
                  onMouseLeave={this.hideTooltip}
                  onClick={this.showTooltip}
                  className={styles.dropdownIcon}
                  src="https://media.dev.myrecruitboard.com/Images/coachIcon.png"
                  alt="icon"
              />
          )}
          {renderAdminLinks(
              <img
                  id="text"
                  onMouseEnter={this.showTooltip}
                  onMouseLeave={this.hideTooltip}
                  onClick={this.showTooltip}
                  className={styles.dropdownIcon}
                  src="https://media.dev.myrecruitboard.com/Images/coachIcon.png"
                  alt="icon"
              />
          )}
          {renderStudentLinks(
              <img
                  id="text"
                  onMouseEnter={this.showTooltip}
                  onMouseLeave={this.hideTooltip}
                  onClick={this.showTooltip}
                  className={styles.dropdownIcon}
                  src={this.state.profileIcon !== '' ?
                      `https://s3.amazonaws.com/myrbimages/${this.state.profileIcon}` :
                      'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png'}
                  alt="icon"
              />
          )}
          {/* eslint-enable*/}

        <ToolTip active={this.state.isTooltipActive} position="bottom" arrow="right" parent="#text">
          <div className={styles.dropdownContainer}>
            <span>
              {renderCocahLinks(
                <span>
                  <Link to="/" >
                    <button className={styles.menuItem}>HOME</button>
                    <Divider />
                  </Link>
                  <Link to="/view/coach/dashboard" >
                    <button className={styles.menuItem}>DASHBOARD</button>
                  </Link>
                  <Divider />
                  <Link to="/settings" >
                    <button className={styles.menuItem}>SETTINGS</button>
                  </Link>
                </span>,
                )}
              {renderStudentLinks(
                <span>
                  <Link to="/" >
                    <button className={styles.menuItem}>HOME</button>
                    <Divider />
                  </Link>
                  <Link to="/dashboard" >
                    <button className={styles.menuItem}>DASHBOARD</button>
                  </Link>
                  <Divider />
                  <Link to="/view/athlete" >
                    <button className={styles.menuItem}>PROFILE</button>
                  </Link>
                  <Divider />
                  <Link to="/settings" >
                    <button className={styles.menuItem}>SETTINGS</button>
                  </Link>
                </span>,
                  )}
            </span>

            {renderAdminLinks(
              <span>
                <Link to="/" >
                  <button className={styles.menuItem}>HOME</button>
                </Link>
                {renderAdminStudentLinks(
                  <span>
                    <Link to="/dashboard" >
                      <button className={styles.menuItem}>DASHBOARD</button>
                    </Link>
                    <Divider />
                    <Link to="/view/athlete" >
                      <button className={styles.menuItem}>PROFILE</button>
                    </Link>
                    <Divider />
                    <Link to="/settings" >
                      <button className={styles.menuItem}>SETTINGS</button>
                    </Link>
                  </span>,
                  )}
                {renderAdminCoachLinks(
                  <span>
                    <Link to="/view/coach/dashboard" >
                      <button className={styles.menuItem}>DASHBOARD</button>
                    </Link>
                    <Divider />
                    <Link to="/settings" >
                      <button className={styles.menuItem}>SETTINGS</button>
                    </Link>
                  </span>,
                  )}
                {renderLogoutLink(
                  <span>
                    <Divider />
                    <button className={styles.menuItem} onClick={this.logoutCurrentUser}>
                         LOGOUT CURRENT USER
                    </button>
                  </span>,
                  )}
              </span>,
              )}
            <Divider />
            <button onClick={() => this.props.logoutUser(this.props.attributes.get('zoneinfo'))} className={styles.menuItem}>SIGNOUT</button>
          </div>
        </ToolTip>
      </div>
    );
  }
}


export default AccountDropdown;



// WEBPACK FOOTER //
// ./src/components/AccountDropdown/AccountDropdown.js